import { render, staticRenderFns } from "./supplierContracts.vue?vue&type=template&id=cda388c0&"
import script from "./supplierContracts.vue?vue&type=script&lang=js&"
export * from "./supplierContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports